// extracted by mini-css-extract-plugin
export default {"discovery_page":"DiscoveryPage_discovery_page__bUP28","logo":"DiscoveryPage_logo__LZ8G+","error":"DiscoveryPage_error__t+DjU"};